module.exports = __webpack_public_path__ + "img/hotel2.4cd2ff0a.png";